import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Fortuna Markets';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const MARKET_ANALYSIS_BASE_URL = env.MARKET_ANALYSIS_ENDPOINT_URL;
export const MARKET_KEY = env.MARKET_KEY;
export const APP_PREFIX_PATH = '/panel';
export const PUBLIC_RECAPTCHA_KEY = '6Le8wpImAAAAAOGEev54OYH7oDvyvfbUGXaWq0RQ';
export const EXTREME_IP_KEY = "9575d75f42bf4f92be33e72f2f6755ac";

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	navType: NAV_TYPE_SIDE,
	mobileNav: false,
	locale: 'en',
	topNavColor: '#3e82f7',
	headerNavColor: '',
	currentTheme: 'light',
	direction: DIR_LTR
};

const langInRoute = window.location.pathname.split("/")[1];
export const AUTH_PREFIX_PATH = "/" + (["en", "fa"].includes(langInRoute) ? langInRoute : THEME_CONFIG.locale);